<template>
  <div>
    <dl
      class="padding-top-md padding-bottom-xl padding-left-5xl padding-right-2xl margin-0 display-flex flex-row flex-items-center flex-wrap"
      style="
        gap: var(--spacing-md);
        border-top: var(--border-width-sm) solid var(--fa-dk-navy);
        --link-color: var(--fa-blue);
        --link-hover-color: var(--white);
        --list-line-height: 1.2;
      "
    >
      <dt
        class="margin-y-0 margin-right-0 size-sm"
        style="font-weight: var(--font-weight-normal); margin-left: calc(var(--spacing-3xl) * -1)"
      >
        <font-awesome-icon
          :icon="$v7.solid.faCircleInfo"
          style="color: var(--fa-blue)"
          size="lg"
        />
        <span class="sr-only margin-left-2xs">Learn about&hellip; </span>
      </dt>
      <dd
        v-for="link in allLinks"
        :key="link.label"
        class="margin-bottom-0 size-sm"
      >
        <a
          v-if="link.external"
          :href="link.path + (link.hash || '')"
          target="_blank"
          rel="noopener noreferrer"
          @click="trackLinkClick(link)"
        >
          {{ link.label }}
        </a>
        <site-link
          v-else
          :to="getDocsPath(link, { version: majorVersion })"
          @click.native="trackLinkClick(link)"
        >
          {{ link.label }}
        </site-link>
      </dd>
    </dl>
  </div>
</template>

<script>
  import { allLearnAboutLinks } from 'app/views/icons/routing.js'
  import { DocsMixin, EventTrackingMixin } from 'app/mixins'

  export default {
    name: 'IconCodeSnippetLinks',

    mixins: [DocsMixin, EventTrackingMixin],

    inject: {
      isWideCustomIcon: {
        default: () => false
      }
    },

    props: {
      hasCustomStyling: {
        type: Boolean
      },
      links: {
        type: Array,
        default: () => []
      },
      selectedStyle: {
        type: String
      },
      majorVersion: {
        type: Number
      }
    },

    data() {
      return {}
    },

    computed: {
      allLinks() {
        // if links are provided, use them directly (e.g. Web Awesome)
        // if no links provided, compute them (e.g. Font Awesome)
        if (this.links && this.links.length > 0) {
          return this.links
        }

        // Font Awesome links are computed here
        return allLearnAboutLinks({
          version: this.majorVersion,
          links: this.links,
          selectedStyle: this.selectedStyle,
          hasCustomStyling: this.hasCustomStyling,
          isWideCustomIcon: this.isWideCustomIcon()
        })
      }
    },

    methods: {
      trackLinkClick(link) {
        const eventData = this.majorVersion ? { version: this.majorVersion.toString() } : {}
        this.$posthog.capture(`icon:docs_${link.label}_link_click`, eventData)
      }
    }
  }
</script>
